// eslint-disable-next-line
import ko from 'imports-loader?define=>false!knockout/build/output/knockout-latest';

window.ko = ko;
